import CustomButton from "@components/CustomButton/CustomButton";
import {
  AccordionDetails,
  AccordionSummary,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./AccordionImg.css";
import {
  CustomAccordion,
  DescriptionAccordion,
  GridAccordion,
  StackStyled,
  TitleAccordion,
} from "./AccordionImg.style";
const AccordionImg = ({ accordionData, img, sxImg, sxGrid, isDev }) => {
  const [expanded, setExpanded] = useState(accordionData.length - 1);
  const handleExpand = (index) => {
    setExpanded(expanded === index ? null : index);
  };
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Grid container spacing={4} alignItems="center" sx={{ ...sxGrid }}>
      <GridAccordion
        item
        xs={12}
        md={6}
        sx={{ paddingLeft: isDev ? "0 !important" : "" }}>
        {accordionData.map((item, index) => (
          <CustomAccordion
            key={index}
            expanded={expanded === index}
            isLast={index === accordionData.length - 1}
            sx={{
              boxShadow: "none",
            }}>
            <AccordionSummary
              onClick={() => handleExpand(index)}
              className={"btn-accordion"}>
              {expanded === index ? (
                <StackStyled>
                  <TitleAccordion>{t(`${item.name}`)}</TitleAccordion>
                  <CustomButton
                    onClick={() => {}}
                    //TODO change this!
                    text={"Save $40"}
                    bgColor={"#fff"}
                    color={"#0F84FF"}
                    noHover={false}
                  />
                </StackStyled>
              ) : (
                <TitleAccordion>{t(`${item.name}`)}</TitleAccordion>
              )}
              <Typography sx={{ fontWeight: "bold", fontSize: "1.5rem" }}>
                {expanded === index ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none">
                    <g clip-path="url(#clip0_389_2914)">
                      <rect
                        opacity="0.3"
                        x="0.507812"
                        y="0.237793"
                        width="31.2465"
                        height="31.2465"
                        rx="15.6232"
                        fill="#0F84FF"
                      />
                      <path
                        d="M12.2592 18.2126C12.1119 18.3739 11.9129 18.4644 11.7056 18.4644C11.4983 18.4644 11.2994 18.3739 11.152 18.2126C11.0793 18.1334 11.0216 18.039 10.9821 17.9349C10.9427 17.8308 10.9224 17.7191 10.9224 17.6062C10.9224 17.4933 10.9427 17.3816 10.9821 17.2775C11.0216 17.1734 11.0793 17.079 11.152 16.9998L15.576 12.206C15.7237 12.045 15.9227 11.9547 16.1301 11.9547C16.3376 11.9547 16.5366 12.045 16.6843 12.206L21.1082 16.9998C21.181 17.079 21.2387 17.1734 21.2782 17.2775C21.3176 17.3816 21.3379 17.4933 21.3379 17.6062C21.3379 17.7191 21.3176 17.8308 21.2782 17.9349C21.2387 18.039 21.181 18.1334 21.1082 18.2126C20.9609 18.3739 20.762 18.4644 20.5547 18.4644C20.3474 18.4644 20.1484 18.3739 20.0011 18.2126L16.1284 14.2812L12.2592 18.2126Z"
                        fill="#F6F5FA"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_389_2914">
                        <rect
                          width="31.2465"
                          height="31.2465"
                          fill="white"
                          transform="translate(31.7529 31.4839) rotate(180)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none">
                    <g clip-path="url(#clip0_389_2920)">
                      <rect
                        x="31.7529"
                        y="31.5918"
                        width="31.2465"
                        height="31.2465"
                        rx="15.6232"
                        transform="rotate(-180 31.7529 31.5918)"
                        fill="#F8F4FF"
                      />
                      <path
                        d="M20.0016 13.6165C20.1489 13.4552 20.3478 13.3647 20.5551 13.3647C20.7624 13.3647 20.9614 13.4552 21.1087 13.6165C21.1814 13.6957 21.2392 13.7901 21.2786 13.8942C21.318 13.9983 21.3383 14.11 21.3383 14.2229C21.3383 14.3358 21.318 14.4475 21.2786 14.5516C21.2392 14.6557 21.1814 14.7501 21.1087 14.8293L16.6847 19.6231C16.5371 19.7841 16.338 19.8744 16.1306 19.8744C15.9232 19.8744 15.7241 19.7841 15.5765 19.6231L11.1525 14.8293C11.0798 14.7501 11.022 14.6557 10.9826 14.5516C10.9432 14.4475 10.9229 14.3358 10.9229 14.2229C10.9229 14.11 10.9432 13.9983 10.9826 13.8942C11.022 13.7901 11.0798 13.6957 11.1525 13.6165C11.2998 13.4552 11.4987 13.3647 11.7061 13.3647C11.9134 13.3647 12.1123 13.4552 12.2596 13.6165L16.1323 17.5479L20.0016 13.6165Z"
                        fill="#0C2E52"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_389_2920">
                        <rect
                          width="31.2465"
                          height="31.2465"
                          fill="white"
                          transform="translate(0.507812 0.345215)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                )}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Stack sx={{ gap: "2rem" }}>
                <DescriptionAccordion>{item.description}</DescriptionAccordion>
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}>
                  <Stack sx={{ display: "flex", flexDirection: "row" }}>
                    <Typography fontWeight={700} className="price">
                      ${item.price}
                    </Typography>
                    <Typography className="month-txt">/month</Typography>
                  </Stack>
                  <CustomButton
                    onClick={() => {
                      navigate("/register", {
                        state: { packId: item._id, packPrice: item.price },
                      });
                    }}
                    //TODO change this!

                    text={"Try 1 month"}
                    bgColor={"#0F84FF"}
                    color={"#fff"}
                    noHover={false}
                    style={{
                      borderRadius: "20.831px",
                      fontWeight: 700,
                      margin: "0",
                    }}
                  />
                </Stack>
              </Stack>
            </AccordionDetails>
          </CustomAccordion>
        ))}
      </GridAccordion>
    </Grid>
  );
};

export default AccordionImg;
